import styled from 'styled-components';

const StyledContent = styled.div`
  text-align: center;
  padding: 10px 45px;

  h3 {
    font-size: 20px;
    font-weight: 600;
    line-height: 28px;
    padding-bottom: 15px;
  }

  p {
    font-size: 15px;
    font-weight: 400;
    line-height: 19px;
    padding-bottom: 15px;
  }
`;
export default StyledContent;
